var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"cases"}},[_c('Header'),_c('Banner'),_c('Portfolio'),_c('Formulario',{attrs:{"formTitle":"Está na hora do seu negócio ir além!","subTitle":"Está na hora do seu negócio ir além!"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }